<template>
  <div>
    <top-bar></top-bar>
    <school-logo></school-logo>
    <nav-bar></nav-bar>
    <router-view></router-view>
    <footer-bar></footer-bar>
  </div>
</template>
<script>
import TopBar from '../../components/TopBar/index.vue'
import SchoolLogo from '../../components/SchoolLogo/index.vue'
import NavBar from '../../components/NavBar/index.vue'
import FooterBar from '../../components/FootBar/index.vue'
export default {
  name: '',
  components: {
    TopBar,
    SchoolLogo,
    NavBar,
    FooterBar,
  },
  data() {
    return {}
  },
}
</script>
